<template>
	<v-container class="px-2 py-0">
		<h2 class="mt-2">Añada los documentos o complete los campos indicados</h2>
		<span style="color: rgba(0, 0, 0, 0.6) !important;"><b>Los archivos añadidos se guardan automáticamente.</b>
			Puede
			abandonar esta página y volver a ella más adelante para continuar la subsanación. Acceda desde los correos
			electrónicos que ha recibido, o desde Umivale Activa online si es despacho usuario de la plataforma.</span>

		<v-row class="mt-2">
			<v-col class="mx-auto">
				<v-alert color="#124D91" text>
					<img alt="info" src="@Base/assets/info.svg" height="32px"
						style="margin: 8px 22px 0 10px; float: left;" />
					<ul style="color: #595959; font-size: 1em; padding-left: 70px; display: block;"
						class="alternar-dots">
						<li>
							<b>¿Necesita enviar un documento de varias páginas?</b>
						</li>
						<li>
							Los campos admiten un solo archivo. Puede agrupar varios documentos comprimiéndolos en un
							único
							archivo zip.
						</li>
						<li>
							<b>¿No dispone de un escáner?</b>
						</li>
						<li>
							Es suficiente con una foto de buena calidad, aunque preferimos el formato pdf.
						</li>
						<li>
							La aportación de <b>documentos incorrectos </b> podrá exigir su subsanación posterior.
						</li>
					</ul>
				</v-alert>
			</v-col>

			<v-col class="col-12">
				<span style="font-size: 20px; font-weight: 600;">
					¿Qué documentación es necesario aportar para subsanar la incidencia ?
				</span>
				<span class="pt-2 fontStyle" style="display: block;">
					Si lo considera necesario, aporte la documentación indicada.
				</span>
				<div class="texto-subsanar">
					<span class="fontStyle">
						Superado el plazo de 15 días hábiles sin aportar documentación, </span><span>procederemos a
						la emisión de la
						resolución
						definitiva, con la información disponible, dictando acuerdo modificatorio de la prestación,
						reclamándole
						posteriormente los importes, totales o parciales, que percibió en su día.
					</span>
				</div>
			</v-col>
		</v-row>

		<v-row>
			<v-col cols="12">
				Estos son los posibles motivos y la documentación requerida en cada caso:
			</v-col>
		</v-row>
		<v-row>
			<v-col class="col-12" v-for="(texto, index) in textosAlegacion" :key="texto.orden">
				<ul class="alternar-dots">
					<li v-html="texto.texto">
					</li>
				</ul>
			</v-col>
		</v-row>

		<v-row class="pt-2">
			<v-col cols="12" no-gutter>
				<FileUploader v-if="!isLoading && documento && documento.idSolicitud"
					:idSolicitud="documento.idSolicitud" :idSolDocumento="documento.idSolDocumento"
					:idTipoDocumento="documento.idTipoDocumento" :nombreArchivo="documento.nombreArchivo"
					titulo="Documentación para subsanar" obligatorio="S" @uploaded="documentoChanged($event)"
					@deleted="deleteDocument($event)" />
			</v-col>
		</v-row>
		<v-row no-gutter>
			<v-textarea class="col-12 text-body-1 mx-2" v-model="observaciones" counter="2000"
				:rules="[validationRules.maxLength(observaciones, 2000)]"
				:placeholder="placeholderObservacion" rows="5" outlined />
		</v-row>
		<v-skeleton-loader v-if="isLoading" type="card" class="mb-4 mx-auto" />

		<v-row v-if="!isLoading" class="my-6">
			<v-col>
				<v-btn class="btn-next" style="float:right;" :disabled="disableContinuar" @click="continueNext()"
					color="primary">Continuar
				</v-btn>
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
import api from '@Base/services/auditoriaService';
import StepBase from './common/StepBase';
import FileUploader from './common/FileUploader.vue'

export default {
	name: 'SubidaDocumentosAlegacion',
	mixins: [StepBase],
	components: {
		FileUploader
	},
	data() {
		return {
			documento: null,
			isLoading: false,
			observaciones: '',
			placeholderObservacion: 'Describa la documentación que ha añadido para subsanar',
			textAlert: 'Puede consultar en qué situación se encuentra este expediente en el documento de apertura de trámite de audiencia que ha recibido.',
			textosAlegacion: []
		}
	},
	computed: {
		disableContinuar() {
			return this.observaciones.length > 2000 || !this.documento.nombreArchivo
		},
	},
	methods: {
		getDocumentoAlegacion() {
			this.isLoading = true;
			const idPrestacion = this.$store.state.solicitud.solicitante.prestacionSolicitada

			api.getDocumentoAlegacion(idPrestacion,
				res => {
					this.documento = { ...res }
					this.observaciones = this.documento.observaciones ? this.documento.observaciones : ''
					this.isLoading = false;
				},
				error => {
					this.isLoading = false;
					this.$emit('alert-event', { text: 'Error al obtener el documento de alegación', color: 'red' });
					console.log(error);
				}
			);
		},
		getTextosAlegacion() {
			api.getTextosAlegacion(
				res => {
					this.textosAlegacion = [...res]
				},
				error => {
					this.$emit('alert-event', { text: 'Error al obtener los textos de la alegación', color: 'red' });
					console.log(error);
				}
			);
		},

		setObservacion() {
			this.documento.observaciones = this.observaciones
			// si se guarda correctamente el campo observaciones redirigimos a la pantalla de firma (declaraciones)
			api.setObservacion(this.documento,
				res => {
					this.$router.push({ name: 'declaraciones', params: { id: this.$store.state.solicitud.tokenAcceso, notificacion: this.$store.state.solicitud.idNotificacion } });
				},
				error => {
					this.$emit('alert-event', { text: 'Error al guardar campo observación', color: 'red' });
					console.log(error);
				}
			);
		},
		deleteDocument(documento) {
			this.documento.nombreArchivo = null;
			this.observaciones = '';
		},
		documentoChanged(documento) {
			this.documento.idSolDocumento = documento.idSolDocumento;
			this.documento.nombreArchivo = documento.nombreArchivo;
		},

		continueNext() {
			this.setObservacion()
		},
	},
	watch: {
		$route(to) {
			this.$store.commit('solicitud/setTituloModulo', this.$store.state.solicitud.solicitante.tituloPrestacion);
			this.$store.commit('solicitud/setPasoActual', 2);
			this.getDocumentoAlegacion()
		},
	},
	beforeRouteEnter(to, from, next) {
		next(vm => {
			vm.$store.commit('solicitud/setTituloModulo', vm.$store.state.solicitud.solicitante.tituloPrestacion);
			vm.$store.commit('solicitud/setPasoActual', 2);
			vm.getDocumentoAlegacion()
			vm.getTextosAlegacion()
		})
	},
	beforeMount() {
		window.onbeforeunload = () => {
			return "¿Estás seguro de abandonar la página? Los cambios no guardados se perderán.";
		};
	},
	beforeDestroy() {
		window.onbeforeunload = null; // Eliminar el evento antes de destruir el componente
	}
}

</script>
<style>
/* Estilo para todos los elementos de la lista */
.alternar-dots li {
	list-style: none;
	/* Oculta los puntos en todos los elementos */
	margin-left: 1em;
	/* Añade un margen izquierdo para la sangría */
	position: relative;
	/* Permite la posición relativa para los elementos li */
	color: rgba(0, 0, 0, 0.6) !important;
}

/* Estilo para elementos pares */
.alternar-dots li:nth-child(odd)::before {
	content: "\2022";
	/* Agrega un punto (•) como contenido antes del elemento */
	position: absolute;
	/* Permite la posición absoluta para los puntos */
	left: -1em;
	/* Ajusta la posición del punto a la izquierda */
	margin-right: 0.5em;
	/* Añade un espacio entre el punto y el texto */
}

/* Estilo para elementos pares (sin punto) */
.alternar-dots li:nth-child(even) {
	margin-bottom: 0.5em;
	/* Añade espacio entre los elementos sin punto y el siguiente */
}

.texto-subsanar {
	line-height: 150%;
}

.fontStyle {
	font-size: 16px;
	font-weight: 600;
	font-family: 'Lato', sans-serif !important;
}
</style>